<template>
  <div id="app">
    <FloatingAlert language="pt-BR" />
    <NewUpdateCmp />

    <TopProgressCmp />
    <TopMenuCmp class="muven-hidden-mobile" />
    <LeftMenuCmp @oncollapsed="handleCollapse" class="muven-hidden-mobile" />
    <BottomMenuCmp class="muven-shown-mobile" />

    <main :class="{
      'left-menu-is-collapsed': isLeftMenuCollapsed,
    }">
      <router-view />
    </main>

    <FooterCmp />
  </div>
</template>

<script>
import Vue from 'vue';
import VueFloatingAlert from 'vue-floating-alert';
import VueCurrencyFilter from 'vue-currency-filter';
import TopMenuCmp from '@/menu/components/TopMenuCmp';
import TopProgressCmp from '@/utils/components/TopProgressCmp';
import LeftMenuCmp from '@/menu/components/LeftMenuCmp';
import BottomMenuCmp from '@/menu/components/BottomMenuCmp';
import LoadingCmp from '@/utils/components/LoadingCmp';
import NothingFoundCmp from '@/utils/components/NothingFoundCmp';
import ResourceNotFoundCmp from '@/utils/components/ResourceNotFoundCmp';
import BreadcrumbCmp from '@/utils/components/BreadcrumbCmp';
import ListCountCmp from '@/utils/components/ListCountCmp'
import NewUpdateCmp from '@/utils/components/NewUpdateCmp'
import FooterCmp from '@/footer/components/FooterCmp'
import VueCalendar from 'v-calendar'
import Multiselect from 'vue-multiselect'
import Highcharts from 'highcharts'
import HighchartsVue from 'highcharts-vue'
import VueMask from 'v-mask'
import addHighchartsMore from 'highcharts/highcharts-more'
import addHighchartHeatMap from 'highcharts/modules/heatmap'
import addHighchartTreeMap from 'highcharts/modules/treemap'
import { applyChartTheme } from '@/utils/services/ChartThemeService'
import { themeState } from '@/utils/services/ThemeService'
import SwitchToggleCmp from '@/utils/components/SwitchToggleCmp'
import 'vue-json-pretty/lib/styles.css';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'v-calendar/lib/v-calendar.min.css'
import 'popper.js';
import 'bootstrap';

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faChartLine,
  faClipboardList,
  faTruckLoading,
  faCubes,
  faPuzzlePiece,
  faBell,
  faChevronRight,
  faSyncAlt,
  faSortDown,
  faHourglassStart,
  faExclamationTriangle,
  faEllipsisV,
  faShippingFast,
  faMoneyBillWave,
  faTimes,
  faEquals,
  faCalendarAlt,
  faRobot,
  faBan,
  faTags,
  faUser,
  faPlusCircle,
  faCrown,
  faCloudDownloadAlt,
  faBox,
  faPlus,
  faSkull,
  faExternalLinkAlt,
  faWindowClose,
  faHandshake,
  faSmile,
  faChevronCircleLeft,
  faChevronCircleRight,
  faThumbsUp,
  faFlagCheckered,
  faEye,
  faThList,
  faSitemap,
  faSave,
  faInfoCircle,
  faEdit,
  faTruckMoving,
  faLink,
  faImages,
  faCircle,
  faTrashAlt,
  faCogs,
  faInfo,
  faChevronDown,
  faChevronUp,
  faStoreAlt,
  faServer,
  faFileDownload,
  faComments,
  faBarcode,
  faPowerOff,
  faClock,
  faHourglassHalf,
  faCheckCircle as faCheckCircleSolid,
  faQuestionCircle,
  faListOl,
  faFileAlt,
  faSpinner,
  faHeadset,
  faSearch,
  faHistory,
  faCloudUploadAlt,
  faRedoAlt,
  faFolderOpen,
  faLock,
  faArrowLeft,
  faSlidersH,
  faKey,
  faCube,
  faCopyright,
  faCreditCard,
  faStream,
  faArrowRight,
  faMinus,
  faCheck,
  faEyeSlash,
} from '@fortawesome/free-solid-svg-icons'

import {
  faCheckCircle,
  faCopy,
} from '@fortawesome/free-regular-svg-icons'

import { mapState } from 'vuex';

library.add(
  faChartLine,
  faClipboardList,
  faTruckLoading,
  faCubes,
  faBell,
  faPuzzlePiece,
  faChevronRight,
  faChevronDown,
  faChevronUp,
  faSyncAlt,
  faSortDown,
  faHourglassStart,
  faCheckCircle,
  faCheckCircleSolid,
  faExclamationTriangle,
  faEllipsisV,
  faShippingFast,
  faMoneyBillWave,
  faTimes,
  faEquals,
  faCalendarAlt,
  faRobot,
  faBan,
  faTags,
  faUser,
  faPlusCircle,
  faWindowClose,
  faCrown,
  faCloudDownloadAlt,
  faBox,
  faPlus,
  faSkull,
  faExternalLinkAlt,
  faHandshake,
  faChevronRight,
  faChevronCircleLeft,
  faChevronCircleRight,
  faSmile,
  faThumbsUp,
  faFlagCheckered,
  faEye,
  faThList,
  faSitemap,
  faSave,
  faInfoCircle,
  faInfo,
  faEdit,
  faTruckMoving,
  faLink,
  faImages,
  faCircle,
  faTrashAlt,
  faCogs,
  faStoreAlt,
  faServer,
  faFileDownload,
  faComments,
  faBarcode,
  faPowerOff,
  faCircle,
  faClock,
  faHourglassHalf,
  faCopy,
  faQuestionCircle,
  faEye,
  faListOl,
  faFileAlt,
  faSpinner,
  faHeadset,
  faSearch,
  faHistory,
  faCloudUploadAlt,
  faRedoAlt,
  faFolderOpen,
  faLock,
  faArrowLeft,
  faSlidersH,
  faKey,
  faCube,
  faCopyright,
  faCreditCard,
  faStream,
  faArrowRight,
  faMinus,
  faCheck,
  faEyeSlash,
)

addHighchartsMore(Highcharts)
addHighchartHeatMap(Highcharts)
addHighchartTreeMap(Highcharts)

Vue.use(VueMask)
Vue.use(HighchartsVue)
Vue.use(VueCalendar)
Vue.use(VueFloatingAlert)
Vue.use(VueCurrencyFilter,
  {
    symbol: 'R$',
    thousandsSeparator: '.',
    fractionCount: 2,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
  })

Vue.component('multiselect', Multiselect)
Vue.component('fa', FontAwesomeIcon)
Vue.component('Loading', LoadingCmp)
Vue.component('Breadcrumb', BreadcrumbCmp)
Vue.component('NothingFound', NothingFoundCmp)
Vue.component('ResourceNotFound', ResourceNotFoundCmp)
Vue.component('SwitchToggle', SwitchToggleCmp)
Vue.component('ListCount', ListCountCmp)

export default {
  name: 'App',
  data() {
    return {
      isLeftMenuCollapsed: false,
    }
  },
  components: {
    TopProgressCmp,
    TopMenuCmp,
    LeftMenuCmp,
    BottomMenuCmp,
    FooterCmp,
    NewUpdateCmp,
  },
  methods: {
    handleCollapse(ev) {
      this.isLeftMenuCollapsed = ev.isCollapsed;
    },
  },
  created() {
    // aqui (e nao no topo do modulo) os estilos ja estao na pagina, entao os tokens resolvem
    applyChartTheme();
  },
  mounted() {
    if (this.subscriber.hasAgreementLink()) {
      this.$router.push('/contrato')
      return
    }
  },
  computed: {
    ...mapState({
      subscriber: state => state.subscriber,
    }),
    // o tema ja aplicado na tela (e nao a escolha do clique): os tokens so mudam depois
    appliedTheme() {
      return themeState.appliedTheme;
    },
  },
  watch: {
    appliedTheme() {
      applyChartTheme();
    },
  },
}
</script>

<style lang="scss">
@import './utils/styles/theme.scss';
@import './utils/styles/overrides.scss';
@import './utils/styles/common.scss';
@import './utils/styles/constants.scss';
@import './utils/styles/theme-vendor.scss';
@import './utils/styles/theme-charts.scss';

#app {
  font-family: 'Source Sans Pro', sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text);
  height: 100vh;
}
</style>
